/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
// import { Dropdown } from "../reuseable";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
// import useLanguage from "../common_hooks/useLanguage";
// import SearchCountingCustom from "../editor_search_import/SearchCountingCustom";
// import { useState } from "react";
// import Modal from "../common_modal/Modal";
import RamIdSelection from "../common_field/RamIdSelection";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
// import dict from "../../Data/dict.json";

/*CONST*/

const SET_RAM = ({
  //variable
  layer,
  properties,

  //function
  set_value_properties,
}) => {
  //localStorage
  // const { language, dict } = useLanguage();

  //state & ref

  //global props
  const { field_editable } = properties;
  const { key, asset_number_field_key } = field_editable || {};
  const { geo_layer_list, layer_id } = layer;


  //variables
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;
  const fields = geo_layer?.fields || [];
  const field = fields.find(f => f?.key === key)

  //functions
  const handleRamAssetNumberFieldKey = (e) => {
    set_value_properties({
      key: "field_editable",
      value: {
        ...field_editable,
        asset_number_field_key: e.target.value
      },
    });
  };


  // contents

  return (
    <main>
      <h1 className="text_bold margin_bottom">Pengaturan RAM</h1>

      <section
        className="container background_grey_light outline_grey"
        style={{ marginBottom: "15px" }}
      >
        <RamIdSelection
          fields={fields}
          field={field}
          handleRamAssetNumberFieldKey={handleRamAssetNumberFieldKey}
          asset_number_field_key={asset_number_field_key}
        />
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(SET_RAM);
